import PhoneInput from "@/components/phoneInput.vue";
import md5 from 'js-md5';
import { showToast, showFailToast } from 'vant';
export default {
  components: {
    PhoneInput
  },
  data() {
    return {
      submitButton: false,
      show: false,
      verifyCodeText: '發送驗證碼',
      isCountdown: false,
      countdown: 60,
      email: '',
      name: '',
      birthday: '',
      birthdayLabel: '',
      phone: '',
      verifyCode: '',
      childCount: '',
      grade: [],
      password: '',
      confirmPassword: '',
      confirmPolicy: '',
      acceptNews: 0,
      redioDisabled: true,
      columns: [{
        text: '一月',
        value: 1
      }, {
        text: '二月',
        value: 2
      }, {
        text: '三月',
        value: 3
      }, {
        text: '四月',
        value: 4
      }, {
        text: '五月',
        value: 5
      }, {
        text: '六月',
        value: 6
      }, {
        text: '七月',
        value: 7
      }, {
        text: '八月',
        value: 8
      }, {
        text: '九月',
        value: 9
      }, {
        text: '十月',
        value: 10
      }, {
        text: '十一月',
        value: 11
      }, {
        text: '十二月',
        value: 12
      }],
      showPicker: false,
      rules: {
        email: [{
          required: true,
          message: '請填寫電郵地址'
        }, {
          pattern: /^.+[@][a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          message: '電郵地址格式不正确'
        }],
        name: [{
          required: true,
          message: '请填写姓名'
        }],
        birthdayLabel: [{
          required: true,
          message: '請選擇生日'
        }],
        verifyCode: [{
          required: true,
          message: '請輸入驗證碼'
        }],
        childCount: [{
          required: true,
          message: '請輸入子女數目'
        }],
        password: [{
          required: true,
          message: '請輸入密碼'
        }, {
          pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
          message: '最少8個字元,最少一個字母,最少一個數字'
        }],
        confirmPassword: [{
          required: true,
          message: '請輸入確認密碼'
        }, {
          validator: this.checkConfirmPassword
        }],
        confirmPolicy: [{
          required: true,
          message: '請閲讀條例並同意'
        }]
      }
    };
  },
  computed: {},
  watch: {
    childCount: {
      handler(curVal, oldVal) {
        if (curVal > 0) {
          this.redioDisabled = false;
        } else {
          this.redioDisabled = true;
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.phone.length < 4 && this.$route.params.tel != undefined) {
      this.phone = this.$route.params.tel;
    }
  },
  methods: {
    opepApp() {
      this.OPENAPP();
    },
    checkConfirmPassword(value) {
      if (value === '') {
        return '請輸入確認密碼';
      } else if (value != this.password) {
        console.log(value);
        console.log(this.password);
        return '密碼不一致';
      } else {
        return '';
      }
    },
    isPhoneValid() {
      console.log(this.phone);
      return /^861\d{10}$/.test(this.phone) || /^852\d{8}$/.test(this.phone);
    },
    onConfirm(result) {
      this.showPicker = false;
      this.birthday = result.selectedOptions[0].value;
      this.birthdayLabel = result.selectedOptions[0].text;
    },
    handleSendVerifyCode() {
      if (!this.isPhoneValid()) {
        this.$refs.phoneInput.handleValidate();
        return;
      }
      if (this.isCountdown) {
        return;
      }
      this.isCountdown = true;
      let timer = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown--;
          this.verifyCodeText = `${this.countdown}秒后重試`;
        } else {
          clearInterval(timer);
          this.isCountdown = false;
          this.countdown = 60;
          this.verifyCodeText = '發送驗證碼';
        }
      }, 1000);
      // 发送验证码的逻辑，可根据实际情况自行调整
      this.$http.post(this.$apis.sendCode + "?loginName=" + this.phone + "&loginType=mobile", {}).then(result => {
        if (result.data.code == 0) {
          console.log("發送成功");
        } else {
          showFailToast(result.data.message);
        }
      });
    },
    handleRegister() {
      this.show = true;

      // 注册的逻辑，可根据实际情况自行调整
      this.$refs.form.validate().then(() => {
        if (!this.confirmPolicy) {
          showToast('请阅读使用条款细则及隐私政策并同意');
          return;
        }
        let p = md5(this.password);
        this.submitButton = true;
        let url = this.$apis.regist;
        let childrenGrade = this.grade.join(",");
        url = url + "?mobile=" + this.phone + "&email=" + this.email + "&password=" + p + "&code=" + this.verifyCode + "&nickName=" + name;
        url = url + "&childrenNum=" + this.childCount + "&childrenGrade=" + childrenGrade + "&birthday=" + this.birthday + "&acceptNews=" + (this.acceptNews ? "1" : "0");
        this.$http.post(url, {}).then(result => {
          if (result.data.code == 0) {
            console.log("注册成功");
            this.show = true;
          }
        }).catch(e => {
          console.log(e.response);
          if (e.response.data.code != 500) {
            showFailToast(e.response.data.message);
          } else {
            showFailToast('系統異常');
          }
          this.submitButton = false;
        });

        // 验证通过
      }).catch(e => {
        //验证失败
        console.log("false");
      });
    }
  }
};